const FLAG_OVERRIDES: Record<string, string> = {
  "united states": "usa.png",
  "united states of america": "usa.png",
  "united kingdom": "UK.png",
  "uk": "UK.png",
  "united arab emirates": "uae.png",
  "uae": "uae.png",
  "czech republic": "czech.png",
  "czechia": "czech.png",
  "south korea": "south-korea-flag.png",
  "korea south": "south-korea-flag.png",
  "north america": "north-america-flag.png",
  "south america": "south-america-flag.png",
  "europe": "europe-flag.png",
  "asia": "asia-flag.png",
  "africa": "africa-flag.png",
  "balkans": "balkans-flag.png",
  "europe and balkans": "europe-and-balkans-flag.png",
  "europe balkans": "europe-and-balkans-flag.png",
  "bosnia and herzegovina": "bosnia.png",
  "british virgin islands": "british-virgi-islands.png",
  "turks and caicos": "turks and caicos.png",
  "trinidad and tobago": "trinidad and tobago.png",
  "palestine": "Palestine.png",
  "moldova": "Moldova.png",
  "netherlands": "netherlalnds.png",
  "ireland": "irelalnd.png",
  "belarus": "belkarus.png",
  "hungary": "hungagry.png",
  "philippines": "philipines.png",
  "liechtenstein": "liechstenstein.png",
  "congo": "cong.png",
  "democratic republic of the congo": "congo-rep-dem.png",
  "congo rep dem": "congo-rep-dem.png",
  "dr congo": "congo-rep-dem.png",
  "republic of the congo": "cong.png",
  "macau": "macao-china.png",
  "macao": "macao-china.png",
  "macedonia": "north-macedonia.png",
  "saint kitts and nevis": "saint-kitts.png",
  "st kitts and nevis": "saint-kitts.png",
  "saint vincent and the grenadines": "saint-vincent.png",
  "st vincent and the grenadines": "saint-vincent.png",
};

export const formatPlanName = (value: string) => {
  const raw = String(value ?? "");
  const withoutGb = raw.replace(/\s*\d+(?:\.\d+)?\s*GB\b/i, "");
  return withoutGb.replace(/\s{2,}/g, " ").trim();
};

const normalizePlanKey = (value: string) => {
  const base = formatPlanName(value);
  return base
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

const REGIONAL_PLAN_KEYS = new Set(
  [
    "Africa",
    "Asia",
    "Europe",
    "North America",
    "South America",
    "Balkans",
    "Europe and Balkans",
    "Europe Balkans",
  ].map((label) => normalizePlanKey(label))
);

export const getPlanSortKey = (value: string) => normalizePlanKey(value);

export const getFlagUrl = (value: string) => {
  const key = normalizePlanKey(value);
  if (!key) return null;
  const filename = FLAG_OVERRIDES[key] ?? `${key.replace(/\s+/g, "-")}.png`;
  return encodeURI(`/flags/${filename}`);
};

export const isRegionalPlan = (value?: string | null) => {
  const key = normalizePlanKey(value ?? "");
  if (!key) return false;
  return REGIONAL_PLAN_KEYS.has(key);
};

export const formatDataGb = (dataByte?: number | null) => {
  if (dataByte === null || dataByte === undefined) return "-";
  const gbValue = dataByte / (1024 * 1024 * 1024);
  if (!Number.isFinite(gbValue)) return "-";
  const formatted = Number.isInteger(gbValue)
    ? gbValue.toString()
    : gbValue.toFixed(2).replace(/\.?0+$/, "");
  return `${formatted} GB`;
};

export const normalizeDiscountPercent = (value: unknown) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  return Math.min(Math.max(parsed, 0), 100);
};

export const formatCurrency = (value: number) => `${value.toFixed(2)}€`;
